import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-505">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-506">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-507">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight text-white" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-508">
            🏆 MEGAPACK MAESTRÍA REIKI
          </h2>
          <p className="text-[#eab308] text-xl md:text-2xl font-bold mb-4" data-id="element-509">
            6 Tomos + 6 Bonos — Niveles I, II y Maestría
          </p>
          <p className="text-gray-300 text-lg md:text-xl font-medium" data-id="element-510">
            360+ páginas — Todo resuelto.
          </p>
        </div>
      </div>
    </section>;
}